"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailStatementTable = void 0;
var react_1 = require("react");
var React = require("react");
var reactTable = require("react-table");
require("../table.css");
require("../../styles/DetailStatement.css");
var reactstrap_1 = require("reactstrap");
var msal_react_1 = require("@azure/msal-react");
var msal_browser_1 = require("@azure/msal-browser");
var authConfig_1 = require("../../authConfig");
var monthlystatement_1 = require("../../api/monthlystatement");
var react_moment_1 = require("react-moment");
/*import Printer, { print } from 'react-pdf-print';*/
var StatementItemTable = function (props) {
    var useTableAny = reactTable.useTable;
    var columns = props.columns;
    var data = props.data;
    var _a = useTableAny({
        columns: columns,
        data: data,
        initialState: { pageIndex: 0 }
    }, reactTable.useFilters, reactTable.usePagination), tableInstance = _a.tableInstance, getTableProps = _a.getTableProps, getTableBodyProps = _a.getTableBodyProps, headerGroups = _a.headerGroups, page = _a.page, nextPage = _a.nextPage, previousPage = _a.previousPage, canNextPage = _a.canNextPage, canPreviousPage = _a.canPreviousPage, pageOptions = _a.pageOptions, 
    // gotoPage,
    // pageCount,
    setPageSize = _a.setPageSize, state = _a.state, prepareRow = _a.prepareRow, setFilter = _a.setFilter, currentPage = _a.currentPage;
    return (React.createElement(reactstrap_1.Table, __assign({}, getTableProps, { responsive: true, className: "detailStatementTable" }),
        React.createElement("thead", null, headerGroups.map(function (headerGroup) { return (React.createElement("tr", __assign({}, headerGroup.getHeaderGroupProps()), headerGroup.headers.map(function (column) { return (React.createElement("th", __assign({ scope: "row" }, column.getHeaderProps()), column.render('Header'))); }))); })),
        React.createElement("tbody", __assign({}, getTableBodyProps), page.map(function (row) {
            prepareRow(row);
            return (React.createElement("tr", __assign({}, row.getRowProps()), row.cells.map(function (cell) {
                return React.createElement("td", __assign({}, cell.getCellProps()), cell.render('Cell'));
            })));
        }))));
};
var DetailStatementTable = function (props) {
    var authRequest = __assign({}, authConfig_1.loginRequest);
    var inProgress = msal_react_1.useMsal().inProgress;
    var _a = react_1.useState('RM'), currencySign = _a[0], setCurrencySign = _a[1];
    var _b = react_1.useState({
        statementId: 0,
        statementNum: '',
        companyName: '',
        recepientName: '',
        recepientAddress: '',
        recepientPhoneNumber: '',
        statementDate: '26 March, 2021',
        items: new Array(),
        subTotal: 0,
        processingFee: 0,
        sLAOffsetAmount: 0,
        sLAOffsetQuantity: 0,
        tax: 0,
        grandTotal: 0,
    }), details = _b[0], setDetails = _b[1];
    var itemColumns = [
        {
            Header: 'Item  Id',
            accessor: 'statementItemNum',
        },
        {
            Header: 'Name',
            accessor: 'name',
        },
        {
            Header: 'Description',
            accessor: 'description',
        },
        {
            Header: 'Price',
            accessor: 'price',
            Cell: function (row) { return (React.createElement("p", { style: { whiteSpace: 'nowrap' } },
                "RM ",
                row.value)); }
        },
        {
            Header: 'Qty',
            accessor: 'quantity',
        },
        {
            Header: 'Amount',
            accessor: 'amount',
            Cell: function (row) { return (React.createElement("p", { style: { whiteSpace: 'nowrap' } },
                "RM ",
                row.value)); }
        },
    ];
    var onLoad = function () {
        monthlystatement_1.fetchStatementById(props.statementId).then(function (response) {
            setDetails(__assign({}, response));
        });
    };
    react_1.useEffect(function () {
        if (details.statementId == 0 && inProgress === msal_browser_1.InteractionStatus.None) {
            onLoad();
        }
    }, [inProgress]);
    /*const ids = ['1']*/
    /*onClick = {() => print(ids)}*/
    /*id = { ids[0]}*/
    /*funtion for printing*/
    //function printdiv(printpage: any) {
    //    var headstr = "<html><head><title></title></head><body>";
    //    var footstr = "</body>";
    //    var newstr = document.all.item(printpage);
    //    var oldstr = document.body.innerHTML;
    //    document.body.innerHTML = headstr + newstr + footstr;
    //    window.print();
    //    document.body.innerHTML = oldstr;
    //    return false;
    //}
    //function printDiv(divName: string) {
    //    var printContents = document.getElementById(divName).innerHTML;
    //    var originalContents = document.body.innerHTML;
    //    document.body.innerHTML = printContents;
    //    window.print();
    //    document.body.innerHTML = originalContents;
    //}
    return (React.createElement(msal_react_1.MsalAuthenticationTemplate, { interactionType: msal_browser_1.InteractionType.Redirect, authenticationRequest: authRequest },
        React.createElement(reactstrap_1.Container, { fluid: true, className: "printme" },
            React.createElement("div", { className: "table-header" },
                React.createElement("div", { className: 'd-none d-md-block' },
                    React.createElement(reactstrap_1.Row, null,
                        React.createElement(reactstrap_1.Col, { md: { size: 6, offset: 3 } },
                            React.createElement("div", { className: "padding-default detailStatementLogo" },
                                React.createElement("img", { src: "./nbitlogo.svg" }))),
                        React.createElement(reactstrap_1.Col, null,
                            React.createElement("div", { className: "padding-default detailStatementButton" },
                                React.createElement(reactstrap_1.Button, { color: "secondary", onClick: function () { return window.print(); } },
                                    React.createElement("img", { src: "./printer.svg", className: "font-icon" }),
                                    " Print"))))),
                React.createElement(reactstrap_1.Row, { className: 'd-md-none d-lg-none' },
                    React.createElement("div", { className: "padding-default" },
                        React.createElement("img", { src: "./nbitlogo.svg" })),
                    React.createElement("div", { className: "padding-default" },
                        React.createElement(reactstrap_1.Button, { color: "secondary", className: "", onClick: function () { return window.print(); } },
                            React.createElement("img", { src: "./printer.svg", className: "font-icon" }),
                            " Print"))),
                React.createElement(reactstrap_1.Row, null,
                    React.createElement(reactstrap_1.Col, { sm: "12" },
                        React.createElement("div", null,
                            React.createElement("h5", null, details.recepientName)))),
                React.createElement(reactstrap_1.Row, null,
                    React.createElement(reactstrap_1.Col, { sm: "5" },
                        React.createElement(reactstrap_1.ListGroup, { flush: true },
                            React.createElement(reactstrap_1.ListGroupItem, { tag: "div", style: { borderBottom: '0px' } },
                                React.createElement(reactstrap_1.Row, null,
                                    React.createElement(reactstrap_1.Col, { sm: "2" },
                                        React.createElement("span", { className: "listgroup-title" },
                                            React.createElement("img", { src: "./location.svg", className: "font-icon" }))),
                                    React.createElement(reactstrap_1.Col, { sm: "10" },
                                        React.createElement("span", { className: "" }, details.recepientAddress)))),
                            React.createElement(reactstrap_1.ListGroupItem, { tag: "div", style: { borderBottom: '0px' } },
                                React.createElement(reactstrap_1.Row, null,
                                    React.createElement(reactstrap_1.Col, { sm: "2" },
                                        React.createElement("span", { className: "listgroup-title" },
                                            React.createElement("img", { src: "./call.svg", className: "font-icon" }))),
                                    React.createElement(reactstrap_1.Col, { sm: "10" },
                                        React.createElement("span", { className: "listgroup-content", style: { paddingLeft: '0px' } }, details.recepientPhoneNumber)))))),
                    React.createElement(reactstrap_1.Col, { sm: "4" }),
                    React.createElement(reactstrap_1.Col, { sm: "3" },
                        React.createElement(reactstrap_1.ListGroup, { flush: true },
                            React.createElement(reactstrap_1.ListGroupItem, { tag: "div", style: { borderBottom: '0px' } },
                                React.createElement(reactstrap_1.Row, { className: "statementId" },
                                    React.createElement(reactstrap_1.Col, { sm: "2" },
                                        React.createElement("span", { className: "listgroup-title" }, "ID    :")),
                                    React.createElement(reactstrap_1.Col, { sm: "10" },
                                        React.createElement("span", { className: "listgroup-content" }, details.statementNum)))),
                            React.createElement(reactstrap_1.ListGroupItem, { tag: "div" },
                                React.createElement(reactstrap_1.Row, { className: "statementId" },
                                    React.createElement(reactstrap_1.Col, { sm: "2" },
                                        React.createElement("span", { className: "listgroup-title" }, "DATE")),
                                    React.createElement(reactstrap_1.Col, { sm: "10" },
                                        React.createElement("span", { className: "listgroup-content" },
                                            React.createElement(react_moment_1.default, { format: "DD MMMM YYYY" }, details.statementDate))))))))),
            details.items != null && details.items.length > 0 ?
                React.createElement(StatementItemTable, { columns: itemColumns, data: details.items }) : null,
            React.createElement("div", { id: "table-footer" },
                React.createElement(reactstrap_1.Row, null,
                    React.createElement(reactstrap_1.Col, { sm: "7" },
                        React.createElement(reactstrap_1.ListGroup, { flush: true },
                            React.createElement(reactstrap_1.ListGroupItem, { tag: "div", className: "padding-default" }))),
                    React.createElement(reactstrap_1.Col, { sm: "5" },
                        React.createElement(reactstrap_1.ListGroup, { flush: true },
                            React.createElement(reactstrap_1.ListGroupItem, { tag: "div", className: "padding-default" },
                                React.createElement(reactstrap_1.Row, null,
                                    React.createElement(reactstrap_1.Col, { sm: "5" },
                                        React.createElement("span", { className: "listgroup-title" }, "Subtotal")),
                                    React.createElement(reactstrap_1.Col, { sm: "2" },
                                        React.createElement("span", { className: "listgroup-content" })),
                                    React.createElement(reactstrap_1.Col, { sm: "5" },
                                        React.createElement("span", { className: "listgroup-content", style: { whiteSpace: "nowrap" } },
                                            currencySign,
                                            " ",
                                            details.subTotal)))),
                            React.createElement(reactstrap_1.ListGroupItem, { tag: "div", className: "padding-default" },
                                React.createElement(reactstrap_1.Row, null,
                                    React.createElement(reactstrap_1.Col, { sm: "5" },
                                        React.createElement("span", { className: "listgroup-title" }, "Processing Fee")),
                                    React.createElement(reactstrap_1.Col, { sm: "2" },
                                        React.createElement("span", { className: "listgroup-content" })),
                                    React.createElement(reactstrap_1.Col, { sm: "5" },
                                        React.createElement("span", { className: "listgroup-content" }, details.processingFee)))),
                            React.createElement(reactstrap_1.ListGroupItem, { tag: "div", className: "padding-default" },
                                React.createElement(reactstrap_1.Row, null,
                                    React.createElement(reactstrap_1.Col, { sm: "5" },
                                        React.createElement("span", { className: "listgroup-title" }, "Tax (10%)")),
                                    React.createElement(reactstrap_1.Col, { sm: "2" },
                                        React.createElement("span", { className: "listgroup-content" })),
                                    React.createElement(reactstrap_1.Col, { sm: "5" },
                                        React.createElement("span", { className: "listgroup-content" },
                                            currencySign,
                                            " ",
                                            details.tax)))),
                            !isNaN(details.sLAOffsetAmount * details.sLAOffsetQuantity) ?
                                React.createElement(reactstrap_1.ListGroupItem, { tag: "div", className: "padding-default" },
                                    React.createElement(reactstrap_1.Row, null,
                                        React.createElement(reactstrap_1.Col, { sm: "5" },
                                            React.createElement("span", { className: "listgroup-title" },
                                                "SLA Breach Offset (",
                                                currencySign,
                                                " ",
                                                details.sLAOffsetAmount,
                                                ")")),
                                        React.createElement(reactstrap_1.Col, { sm: "2" },
                                            React.createElement("span", { className: "listgroup-content" },
                                                currencySign,
                                                " ",
                                                details.sLAOffsetQuantity)),
                                        React.createElement(reactstrap_1.Col, { sm: "5" },
                                            React.createElement("span", { className: "listgroup-content" },
                                                currencySign,
                                                " ",
                                                details.sLAOffsetAmount * details.sLAOffsetQuantity))))
                                : null))),
                React.createElement(reactstrap_1.Row, null,
                    React.createElement(reactstrap_1.Col, { sm: "7" },
                        React.createElement(reactstrap_1.ListGroup, { flush: true },
                            React.createElement(reactstrap_1.ListGroupItem, { tag: "div", className: "padding-default" }, "Monthly Statement was created on a computer and is valid without signature and seal."))),
                    React.createElement(reactstrap_1.Col, { sm: "5" },
                        React.createElement(reactstrap_1.ListGroup, { flush: true },
                            React.createElement(reactstrap_1.ListGroupItem, { tag: "div", className: "padding-default" },
                                React.createElement(reactstrap_1.Row, null,
                                    React.createElement(reactstrap_1.Col, { sm: "5" },
                                        React.createElement("span", { className: "listgroup-title" }, "Grand Total")),
                                    React.createElement(reactstrap_1.Col, { sm: "2" },
                                        React.createElement("span", { className: "listgroup-content" })),
                                    React.createElement(reactstrap_1.Col, { sm: "5" },
                                        React.createElement("span", { className: "listgroup-content", style: { whiteSpace: "nowrap" } },
                                            currencySign,
                                            " ",
                                            details.grandTotal)))))))))));
};
exports.DetailStatementTable = DetailStatementTable;
{ /**/ }
{ /*
 * <Row>
                <Col sm="8">
                    <div className="padding-default">
                        <img src="http://www.nbit.technology/assets/image/nbit-logo-transparent.svg" />
                    </div>
                </Col>
                <Col sm="4">
                    <div className="padding-default">
                        <Button color="secondary">
                            <img src="./printer.svg" className="font-icon" />
                            {" Print"}
                        </Button>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col sm="12">
                    <div>
                        <h5>Firdhaus Ahmad</h5>
                    </div>
                </Col>
            </Row>
 */
}
//# sourceMappingURL=DetailStatementTable.js.map